import ExtendedIcon from './ExtendedIcon';

export default ExtendedIcon;
